export default __webpack_public_path__ + "static/media/w1.407a7d1e.jpg";